import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './style.css';
import { MobileInputContainer, MobileBackButton,MobileButton, LoadingMask } from '../../../../Shared';
import { validateCode } from '../../../../helpers/utils';
import {
    triggerVerificationCode,
    submitVerificationCode,
} from "../../../../actions/actions";
import { Button } from "react-bootstrap";
import { LoadingState } from '../../../../helpers/enum';

const VerifyScreen = (props) => {
    const { item, match: { params }, history } = props;
    const [value, setValue] = useState('');
    const [valid, setValidity] = useState(false);

    const resendCode = () => {
        if (params.type === 'email') {
            props.triggerVerificationCode({
                address: item,
                id: props.match.params.id
            },
                "DeliveryAddresses"
            )
        } else {
            let phoneNumber = item.split('-');
            props.triggerVerificationCode(
                {
                    phoneNumber: phoneNumber[2] + phoneNumber[3],
                    areaCode: phoneNumber[1],
                    countryCode: phoneNumber[0],
                    id: props.match.params.id
                },
                "PhoneNumber"
            )
        }
    }

    const submitCode = () => {
        if (params.type === 'email') {
            props.submitVerificationCode(
                {
                    address: item,
                    id: props.match.params.id,
                    verificationCode: value,
                    verifiedBy: "NotificationCenter"
                },
                "DeliveryAddresses"
            ).then((res) => {
                if(res){
                history.push('/alertPreferences/addOrEditMethodComponent')
                }
            })
        } else {
            let phoneNumber = item.split('-');
            props.submitVerificationCode(
                {
                    phoneNumber: phoneNumber[2] + phoneNumber[3],
                    areaCode: phoneNumber[1],
                    countryCode: phoneNumber[0],
                    address: item,
                    verificationCode: value,
                    id: props.match.params.id,
                    verifiedBy: "NotificationCenter"
                },
                "PhoneNumber"
            ).then((res) => {
                if(res){
                history.push('/alertPreferences/addOrEditMethodComponent')
                }
            })
        }
    }

    return (
        <div>  {props.deliveryMethodState === LoadingState.PENDING &&  <LoadingMask ctrlCss="overlay" />}

        <div className="mobilecontainer-box mobile-edit mobile-padding-right">
        <MobileBackButton
                        href={'#/alertPreferences/addOrEditMethodComponent'}
                    />
             
            <div className="header">
                <h2 className="header-heading smallFont greenColor unbold">
                    Security Confirmation
                </h2>
                <div className="header-description">
                    For the safety of your accounts, please enter the One-Time Code sent to the
                    email or phone number you provided.
                </div>
            </div>

            <MobileInputContainer
                className="margin-top-unset"
                inputLabel={'One-Time Code'}
                hideHeader={false}
                inputValue={value}
                validationMessage={"Enter valid One-Time Code"}
                showValidation={valid}
                needMask={true}
                changeHandler={(e) => {
                    let val = e.target.value;
                    setValue(val);
                    setValidity(validateCode(val));
                }}
                maskValue="99999999"
            />
            <Button className="verify-resend blueColor mobile-font-family" tabIndex={0} variant='link' onClick={() => resendCode()}>
                Resend One-Time Code
                </Button>
            <div className="button-block-dock-bottom">
                <MobileButton
                    whichbutton='new'
                    buttontext='Submit'
                    disabled={!valid}
                    callbackHandler={() => submitCode()}
                />

            </div>
        </div>
        </div>
    )
};

const mapStateToProps = state => {
    const {
        currentValue
    } = state.bankingAlertsReducer;
    return {
        item: currentValue,
        deliveryMethodState: state.accountAlertsReducer.deliveryMethodState,
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            triggerVerificationCode,
            submitVerificationCode
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyScreen);
